<template>
	<div class>
		<!-- Modal Component -->
		<ModalBox
			v-model="legacyModalVisible"
			placement="left"
			size="md"
			hide-close
			header-class="!hidden"
			:wrapper-classes="'add-platform'"
		>
			<div class="modal-container">
				<div class="px-3 mb-2 flex flex-wrap items-start">
					<div class="mt-3 w-2/3">
						<h3 class="add-platform-title mt-2 mb-4">
							New Publish Platform
						</h3>
					</div>
					<div class="mt-3 text-right w-1/3">
						<form-button type="link" isIcon @click="dismiss"> 
							<icon-base>
								<icon-close />
							</icon-base>
						</form-button>
					</div>
				</div>
				<div class="px-3 flex flex-wrap items-start">
					<!-- Case total destination -->
					<div class="w-full">
						<Alert type="normal" class="flex p-2 mb-3"
							v-if="platformUsage && platformUsage.totalDestination">
							<div>
								<div class="text-dark-9 text-s-m text-500 m-0">You have used {{ platformUsage.usedDestination }}/{{
									platformUsage.totalDestination }} destinations.</div>
							</div>
						</Alert>
					</div>
					<!-- Case unique/extra destination -->
					<div class="w-full">
						<Alert type="normal" class="flex p-2 mb-3"
							v-if="platformUsage && platformUsage.uniqueDestination && platformUsage.uniqueDestination.limit">
							<div>
								<div class="text-dark-9 text-s-m text-500 m-0">You have used {{ platformUsage.uniqueDestination.used }}/{{
									platformUsage.uniqueDestination.limit }} unique destinations and {{
									platformUsage.extraDestination.used }}/{{ platformUsage.extraDestination.limit }} extra ones<span
										v-if="getStreamtype()"> across all {{ getStreamtype() }}</span>.</div>
								<div class="text-dark-7 text-s-s font-normal m-0">Need more? <a class="text-underline text-dark-8"
										target="_blank" href="/app/subscribe">Upgrade</a> here.</div>
							</div>
						</Alert>
					</div>
					<!-- Internal Workflow -->
					<!-- <div class="mb-3 w-full">
						<div class="border-[1px] border-surface-2 rounded-lg p-3 cursor-pointer hover:bg-surface-3" :class="{ active: internalWorkflow, 'internal-workflow': internalWorkflow }" @click="selectInternalWorkflow">
							<div class="flex items-center">
								<img src="@/assets/castr-red-dot.svg" alt="Castr" class="">
								<span class="text-l text-500">&nbsp;&nbsp;Internal Workflow&nbsp;&nbsp;&nbsp;</span>
								<Tooltip content="You can select streams within Castr as custom destination.">
									<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-dark-9 ml-2">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14 7.5C14 11.366 10.866 14.5 7 14.5C3.13401 14.5 0 11.366 0 7.5C0 3.63401 3.13401 0.5 7 0.5C10.866 0.5 14 3.63401 14 7.5ZM8 4.5C8 5.05228 7.55228 5.5 7 5.5C6.44772 5.5 6 5.05228 6 4.5C6 3.94772 6.44772 3.5 7 3.5C7.55228 3.5 8 3.94772 8 4.5ZM7.75 8C7.75 7.58579 7.41421 7.25 7 7.25C6.58579 7.25 6.25 7.58579 6.25 8V11C6.25 11.4142 6.58579 11.75 7 11.75C7.41421 11.75 7.75 11.4142 7.75 11V8Z" fill="currentColor"/>
									</svg>
								</Tooltip>
							</div>
						</div>
					</div> -->
				</div>
				<div class="flex flex-wrap" v-if="platformListProcessing">
					<Spinner text="Retrieving data..." classes="text-dark-8 my-3" spinner-color="var(--c-dark-8)"
						spinner-size="15px" />
				</div>
				<ul class="platform-list list-none mx-0 flex flex-wrap" v-if="!platformListProcessing">
					<li class="mb-4 w-1/2 md:w-1/3">
						<div :class="{ active: customPlatform }" class="platform-item p-2" @click="selectPlatform()">
							<div class="platform-icon">
								<icon-base :width="24" :height="24" width-view-box="24" height-view-box="24" fill="none"><icon-settings /></icon-base>
							</div>
							<div class="platform-label">
								Custom
							</div>
						</div>
					</li>
					<li class="mb-4 w-1/2 md:w-1/3" v-for="(plat, index) in platformTemplates" :key="index"
						@click="selectPlatform(plat)">
						<div v-if="plat.name !== 'youtube'" class="platform-item p-2"
							:class="{ active: plat.name === platform.name }">
							<div class="platform-icon">
								<img width="100" class="mx-auto" :src="plat.icon">
							</div>
							<div class="platform-label">
								{{ plat.name === 'twitter' ? 'X (Twitter)' : plat.name }}
							</div>
						</div>
					</li>
				</ul>
				<div class="flex flex-wrap">
					<div class="w-full">
						<div v-if="stream.type === 'unavail'">
							<hr class="divider">
							<p class="text-center font-normal text-s-md mt-4">Want to stream to your website too?</p>
							<p class="text-center font-normal text-s-md">Check out our <a class="link-main font-bolder"
									href="#">Demo</a> for the Live Stream product.</p>
						</div>
					</div>
				</div>
			</div>

		</ModalBox>

		<Teleport to="body">
			<section
				v-if="legacyModalVisible"
				class="second-modal"
				:class="{ showform: stage >= 1, expand: internalWorkflow }"
			>
				<Transition name="second-modal-swap" mode="out-in">
				<div v-if="internalWorkflow" key="internal-workflow">
					<add-castr-stream-2
						:stream="stream"
						@platform-saved="onCastrStreamPlatformSaved"
						@dismiss="unselectPlatform"/>
				</div>
				<div v-else class="second-modal-content" :key="customPlatform ? 'custom' : (platform.name || 'none')">
					<div class="flex flex-wrap">
						<div class="w-full">
							<h3 v-if="customPlatform" class="platform-name text-center py-4 mb-0 text-s-xl bg-dark-3 text-uppercase">
								Custom Platform</h3>
							<div v-else class="py-4 mb-0 text-s-xl bg-dark-3 text-center"> <img class="platform-icon_secondary mx-auto"
									width="100" :src="platform.icon"></div>
						</div>
					</div>
					<div class="px-4 flex flex-wrap">
						<div class="w-full">
							<Alert v-if="error" type="error" class="mt-3">
								<div>{{ error.message }}</div>
								<div v-if="error.subscription" class="text-center">
									<FormButton type="link" size="sm" href="/app/subscribe">
										<strong>upgrade now</strong>
									</FormButton>
								</div>
							</Alert>
						</div>
					</div>
					<div class="px-4 mt-4 flex flex-wrap">
						<div class="w-full">
							<div v-if="!configRequired" class="text-center">
								<div v-if="serviceLinkProcessing">
									<p v-if="serviceLinkError && serviceLinkConflict">
										This <span class="text-capitalize">{{ platform.name }}</span> account is already linked with the stream
									</p>
									<p v-else-if="serviceLinkError">
										sorry, couldn't link with specified <span class="text-capitalize">{{ platform.name }}</span> account
									</p>
									<p v-else>
										<span v-if="linkedServiceCreds"><span class="text-capitalize">{{ platform.name }}</span> Connected, saving destination…</span>
										<span v-else>Connecting to <span class="text-capitalize">{{ platform.name }}</span></span>
										&nbsp;
										<i class="fas fa-spinner fa-spin" />
									</p>
									<form-button type="secondary" v-if="!linkedServiceCreds || serviceLinkError" @click="cancelServiceLinking"> 
										Cancel
									</form-button>
								</div>
								<div v-else>
									<!-- <div>
										<p class="text-s-m text-dark-8 mb-2">I would connect to my <span class="text-capitalize">{{ platform.name
										}}</span> account</p>
										<p v-if="isServiceAlreadyLinked()" class="text-danger mb-2">
											<span class="text-capitalize">{{ platform.name }}</span> is already linked for this stream
										</p>
										<a v-else target="_blank" @click="getServiceOAuthUrl()">
											<form-button class="w-full justify-center" :disabled="isSchedulerInfiniteLoop" v-if="platform.name === 'facebook live'" @click="onServiceAuthURLTap"> 
												Continue With Facebook
											</form-button>
											<form-button class="w-full justify-center" :disabled="isSchedulerInfiniteLoop"  v-else @click="onServiceAuthURLTap"> 
												Connect
												to&nbsp;<span class="text-capitalize">{{ platform.slug || platform.name }}</span>
											</form-button>
										</a>
										<p class="text-s-s text-dark-6" v-if="isSchedulerInfiniteLoop">Due to Facebook restriction, Infinite
											Loop mode cannot be used with option.</p>
									</div>
									<div class="text-dark-8 mt-2 mb-4 lined">
										<span class="searator-text">or</span>
									</div> -->
									<div>
										<p class="text-dark-8 text-s-m mb-2">I would provide server and stream key</p>
										<form-button class="w-full justify-center" :disabled="isBroadcastSubscription && platform.name === 'facebook live'" @click="ignoreServiceLinking"> 
											Setup with Server/Key
										</form-button>
										<div v-if="isBroadcastSubscription && platform.name === 'facebook live'">
											Use custom RTMP to add Facebook Page/Group or Upgrade to use this feature
										</div>
									</div>

									<div class="mt-3">
										<form-button class="w-full justify-center" type="secondary" @click="unselectPlatform"> 
											Cancel
										</form-button>
									</div>
									<div class="doc mt-2">
										<a class="text-s-s text-dark-6 inline-flex items-center" target="_blank"
											href="http://docs.castr.com/en/articles/2291793-how-to-connect-facebook-live-with-castr"
											v-if="platform.name === 'facebook live'"><img src="@/assets/images/book.png" class="mr-2" alt="Doc"> How to connect
											Facebook to Castr</a>
										<a class="text-s-s text-dark-6 inline-flex items-center" target="_blank"
											href="https://docs.castr.com/en/articles/5369538-how-to-connect-youtube-with-castr"
											v-if="platform.name === 'youtube events'"><img src="@/assets/images/book.png" class="mr-2" alt="Doc"> How to
											connect YouTube to Castr</a>
									</div>
								</div>
							</div>
							<div v-else>
								<div class="field-container mt-4 flex flex-wrap" v-if="customPlatform">
									<div class="px-3 md:px-3 py-2 w-full">
										<div class="custom-platform-type">
											<ul class="flex items-center justify-between text-center mb-0">
												<li class="text-dark-9 text-s-m" :class="customMode === 'RTMP' ? 'active' : ''"
													@click="onCustomModeChanged('RTMP')">RTMP</li>
												<li class="text-dark-9 text-s-m" :class="customMode === 'SRT' ? 'active' : ''"
													@click="onCustomModeChanged('SRT')">SRT</li>
											</ul>
										</div>
									</div>
								</div>

								<div v-if="customPlatform && customMode === 'SRT'" class="field-container mt-4">
									<!-- host -->
									<FormInput label="Host" v-model="customSrtPlatform.host"  placeholder="srt-ingest.example.com" class="mb-2" @keypress="onInputChange('host')" @keyup="onInputChange('host')"  :isError="isError('host')" :helper="errorText('host')"/>
									<!-- port -->
									<FormInput label="Port" v-model="customSrtPlatform.port"  placeholder="9998" class="mb-2" @keydown="onInputChange('port')" @keyup="onInputChange('port')" :isError="isError('port')" :helper="errorText('port')"/>

									<!-- stream id -->
									<FormInput label="Stream Id" v-model="customSrtPlatform.streamId"  placeholder="stream id" class="mb-2" @keypress="onInputChange('streamId')" @keyup="onInputChange('streamId')" :isError="isError('streamId')" :helper="errorText('streamId')"/>
									<!-- latency -->
									<FormInput label="Latency" v-model="customSrtPlatform.latency"  placeholder="120" class="mb-2" @keypress="onInputChange('latency')" @keyup="onInputChange('streamId')" :isError="isError('latency')" :helper="errorText('latency')"/>
									<FormInput label="Passphrase" v-model="customSrtPlatform.passphrase"  placeholder="Passphrase" class="mb-2" @keypress="onInputChange('passphrase')" @keyup="onInputChange('passphrase')" :isError="isError('passphrase')" :helper="errorText('passphrase')"/>
								</div>

								<div v-else-if="shouldConfigureServer()" class="field-container mt-4">
									<p v-show="formErrors.server" class="text-danger">
										<!-- specify {{ customPlatform && 'destination' || platform.name }} server -->
										invalid {{ customPlatform && 'destination' || platform.name }} ingest address
									</p>
									<!-- <input v-if="customPlatform || platform.customServer" -->
									<div v-if="checkServerInputMode('input')">
										<FormInput :label="'streaming ' + (customPlatform && 'platform address' || 'server')" v-model="platform.server" :placeholder="platform.serverInputPlaceholder || 'rtmp://broadcaster_addr/'" class="mb-2" @keypress="onInputChange('server')" @keyup="onInputChange('server')" :isError="isError('server')" :helper="errorText('server')"/>
										<div v-if="customPlatform">
											<p v-show="customSrtPlatformErrors.server && !formErrors.server" class="text-danger">
												{{ customSrtPlatformErrors.server }}
											</p>
											<FormCheckbox class="mb-2" v-model="isAuthRequired" :inputValue="true" name="is-auth-required" label="Authentication Required" />
											<div v-if="isAuthRequired">
												<FormInput v-model="rtmpAuthUsername" placeholder="Username" class="mb-2" />
												<FormInput v-model="rtmpAuthPassword" type="password" placeholder="Password" class="mb-2" @blur="checkPassword" :isError="!isRtmpPassValid" :helper="!isRtmpPassValid ? '@ symbol is not supported in password, please change the password.' : null" />
											</div>
										</div>
									</div>
									<div v-else-if="checkServerInputMode('chunks')" class="input-container" @click="focusServerKeySegment">
										<div v-for="(segment, index) in platform.serverKeySegments" :key="index">
											<FormInput v-if="segment.input" v-model="platform.serverKeySegmentValues[index]" :placeholder="segment.placeholder" class="mb-2" @change="computePlatformServerFromSegments" @keypress="onInputChange('server')" />
											<div v-else-if="!segment.hidden" class="value-placeholder">
												{{ segment.text || segment }}
											</div>
										</div>
									</div>
									<drop-down-menu v-else-if="checkServerInputMode('select')" id="dropdown-1" type="flat"
										class="region-dropdown w-full mb-2" listClasses="dropdown-menu_md test w-full mt-0" size="md">
<template #toggle-button>
											<div class="flex items-center w-full">
												<span class="font-normal text-s-m" v-if="chosenServer">
													<span>{{ chosenServer }}</span>
												</span>
												<span class="text-dark-8 font-normal text-s-m" v-else>Select one</span>
												<icon-base class="ml-auto flex-shrink-0" :width="10" :height="6"><icon-caret-down /></icon-base>
											</div>
										</template>

										<template #menu-items>
											<drop-down-menu-item :key="server.id" v-for="server in platform.servers"
												@click="selectServer(server)">{{ server.text }}
											</drop-down-menu-item>
										</template>
									</drop-down-menu>
								</div>
								<p class="text-dark-7 text-size-m" v-if="linkedServiceCreds">
									Some ingest details captured from connected <span class="text-capitalize">{{ platform.name }}</span> account
								</p>
								<div v-else-if="customMode !== 'SRT'" class="field-container mt-4">
									<FormInput label="streaming key" v-model="platform.streamKey" :placeholder="platform.streamKeyPlaceholder || '#streaming_key'" class="mb-2" @keypress="onInputChange('streamKey')" @keyup="onInputChange('streamKey')" />
								</div>

								<!-- stream metadata form -->
								<div v-if="canConfigureMetadata()">
									<div
										v-if="platform.serviceAuthorization.subChannelRequired && !platform.serviceAuthorization.autoSelectDefaultSubChannel"
										class="field-container mt-4">
										<label>
											{{ platform.serviceAuthorization.subChannelFieldLabel || 'Publishing Channel' }}
										</label>

										<drop-down-menu id="service-subchannels-dropdown" type="flat" class="region-dropdown w-full mb-2" listClasses="dropdown-menu_md test w-full mt-0" size="md" @show="onSubchannelListToggle(true)"
											@hide="onSubchannelListToggle(false)">
<template #toggle-button>
												<div class="flex items-center w-full">
													<span class="font-normal text-s-m" v-if="selectedSubChannel">
														<span>{{ selectedSubChannel.name }}</span>
													</span>
													<span class="text-dark-8 font-normal text-s-m" v-else>Select one</span>
												<icon-base class="ml-auto flex-shrink-0" :width="10" :height="6"><icon-caret-down /></icon-base>
												</div>
											</template>

<template #menu-items>
<drop-down-menu-item v-for="subchannel in platform.subChannelList" :key="subchannel.id" :class="{
													active: selectedSubChannel && subchannel.id === selectedSubChannel.id,
													disabled: isSubChannelDisabled(subchannel)
												}" @click="changeSubChannelSelection(subchannel)" customClasses="block page-item">
												<div class="main text-s-m text-dark-9 text-500">
													{{ subchannel.name }}
												</div>
												<div v-show="subchannel.type" class="desc text-s-s text-dark-6">
													<span v-show="platform.name === 'facebook live'">facebook</span> <span>{{ subchannel.type
													}}</span>
												</div>
												<div class="ml-1 hint-upgrade text-s-xs color-danger">
													Not available on Trial plan
												</div>
											</drop-down-menu-item>
</template>
</drop-down-menu>
									</div>

									<!-- <div v-if="hasMetaProp('title')" class="field-container"> -->
									<div v-if="canConfigureMetadata('title') || platform.name === 'youtube events'"
										class="field-container mt-4">
										<FormInput :label="'Stream Title ' + (showTitleLimitTracking ? '(' + platform.configurableMetadata.title.length + '/100)' : '')" v-model="platform.configurableMetadata.title" :maxlength="maxLengthTitle" placeholder="Enter stream title" class="mb-2" />
									</div>

									<!-- <div v-if="hasMetaProp('description')" class="field-container"> -->
									<div v-if="canConfigureMetadata('description') || platform.name === 'youtube events'"
										class="field-container mt-4">
										<FormText :label="'Stream Description ' + (showTitleLimitTracking ? '(' + platform.configurableMetadata.description.length + '/5000)' : '')" class="mb-3" v-model="platform.configurableMetadata.description"
											:maxlength="maxLengthDescription" placeholder="Enter stream description" />

									</div>

									<div v-if="platform.name === 'youtube events'"
										class="field-container mt-4 mb-4">
										<label for="">
											Privacy Status
										</label>

										<drop-down-menu ref="youtubePrivacyDropdownInDialog" type="secondary" customClasses="w-full text-sm h-8 bg-surface-3 hover:bg-surface-4 rounded-md flex items-center px-3 capitalize text-tiny"
												customDropdownClass="w-full"
												>
											<template #toggle-button>
												{{ platform.configurableMetadata.privacyStatus || selectedPrivacyStatus }}
												<icon-base
													class="ml-auto">
													<icon-chevron-down />
												</icon-base>
											</template>
											<template #menu-items>
												<drop-down-menu-item customClasses="max-w-full w-full h-auto flex flex-col text-wrap text-left items-start px-3 py-2 text-tiny hover:bg-surface-4" @click="onPrivacySettingsChanged('public', platform)">
													Public
												</drop-down-menu-item>
												<hr>
												<drop-down-menu-item customClasses="max-w-full w-full h-auto flex flex-col text-wrap text-left items-start px-3 py-2 text-tiny hover:bg-surface-4" @click="onPrivacySettingsChanged('unlisted', platform)">
													Unlisted
												</drop-down-menu-item>
												<hr>
												<drop-down-menu-item customClasses="max-w-full w-full h-auto flex flex-col text-wrap text-left items-start px-3 py-2 text-tiny hover:bg-surface-4" @click="onPrivacySettingsChanged('private', platform)">
													Private
												</drop-down-menu-item>
											</template>
										</drop-down-menu>

									</div>

									<div v-if="canConfigureMetadata('game')" class="field-container mt-4">
										<FormInput label="Category" v-model="platform.configurableMetadata.game" @input="onChangeGameName" placeholder="Enter a category or game" class="mb-2" />

										<drop-down-menu id="twitch-game-dropdown" type="flat" class="region-dropdown w-full mb-2" listClasses="dropdown-menu_md test w-full mt-0" size="md" customClasses="twitch-dropdown-toggle"
											ref="twitch-dropdown">
<template #menu-items>
<drop-down-menu-item v-for="category in twitchCategories" :key="category.id" @click="onSelectTwitchCategory(category)" customClasses="block page-item">
												<div class="main text-s-m text-dark-9 text-500">
													{{ category.name }}
												</div>
											</drop-down-menu-item>
</template>
</drop-down-menu>

									</div>

									<div v-if="hasMetaProp('persistent')" class="field-container mt-4">
										<div class="label">
											{{ getMetadataPropValue('persistent', true).label }}
										</div>

										<i v-if="platform.configurableMetadata.persistent" class="fas fa-toggle-on toggle-control enabled"
											@click="setMetadataPropValue('persistent', false)" />

										<i v-else class="fas fa-toggle-off toggle-control" @click="setMetadataPropValue('persistent', true)" />
									</div>
								</div>
								<form-button class="w-full justify-center" disabled v-if="processing"> 
									<Spinner text="Creating..." classes="text-dark-8" spinner-color="var(--c-dark-8)" spinner-size="15px" />
								</form-button>
								<div v-if="!processing && (!serviceLinkProcessing || configRequired)">
									<form-button v-if="canSave" class="w-full justify-center mb-2" @click="onSavePlatform" :disabled="!isRtmpPassValid || ((customSrtPlatformErrors.host.length + customSrtPlatformErrors.latency.length + customSrtPlatformErrors.port.length + customSrtPlatformErrors.server.length + customSrtPlatformErrors.streamId.length + customSrtPlatformErrors.streamKey.length) > 0)"> 
										Create Platform
									</form-button>
									<form-button type="secondary" class="w-full justify-center" @click="unselectPlatform"> 
										Cancel
									</form-button>
								</div>
							</div>
						</div>
					</div>
				</div>
				</Transition>
			</section>
		</Teleport>

		<alert-modal
			:description="`Please add Castr application to your Facebook Group '${selectedSubChannel && selectedSubChannel.name}' to connect with Castr`"
			modal-id="modal-facebook-groups-guide"
			message="Please add Castr app to your Facebook Group (Settings -> Manage Advanced Settings -> Apps) or check your permission to stream to Group on Facebook. If you still encounter a problem, please contact our support team."
			ok-text="Close" ok-href="https://web.facebook.com/help/261149227954100?_rdc=1&_rdr" />

		<confirm-modal modal-id="modal-custom-server-premium-feat"
			message="This feature is only available in our paid subscriptions" ok-text="Upgrade now" cancel-text="No thanks"
			@modal-confirm="navigatePaymentsPage" />
	</div>
</template>

<script>
import { showModal, hideModal } from '@/Utils/modalBus'
import ModalBox from './ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import _ from 'lodash';
import { v4 } from "uuid"
import Spinner from "@/components/ui/Spinner.vue";
import StreamService from '@/services/StreamService';
import IntegrationService from '@/services/IntegrationService';
import AlertModal from '@/components/modals/AlertModal.vue';
import Alert from '@/components/Atoms/Alert.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import FormButton from '../../components/Atoms/FormButton.vue';
import FormInput from '../../components/Atoms/FormInput.vue';
import FormCheckbox from '../../components/Atoms/FormCheckbox.vue';
import IconBase from '@/components/icon/IconBase.vue'
import IconClose from '@/components/icon/IconClose.vue'
import DropDownMenu from '../../components/Atoms/DropDownMenu.vue';
import DropDownMenuItem from '../../components/Atoms/DropDownMenuItem.vue';
import AddCastrStream2 from "@/components/ui/AddCastrStream2.vue";
import Tooltip from '@/components/Atoms/Tooltip.vue';
import FormText from '@/components/Atoms/FormText.vue';

import utils from '@/utils';
import IconChevronDown from '@/components/icon/IconChevronDown.vue';
import IconSettings from '@/components/icon/IconSettings.vue';
import IconCaretDown from '@/components/icon/IconCaretDown.vue';

export default {
	name: 'AddChannelsModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'modal-add-channel',
	components: {
		IconChevronDown,
		ModalBox,
		Alert,
		AlertModal,
		ConfirmModal,
		Spinner,
		FormButton,
		FormInput,
		FormCheckbox,
		IconClose,
		IconBase,
		DropDownMenu,
		DropDownMenuItem,
		AddCastrStream2,
		Tooltip,
		FormText,
		IconSettings,
		IconCaretDown,
	},
	props: {
		stream: {
			type: Object,
			required: true,
			validator(v) {
				return Object.prototype.hasOwnProperty.call(v, '_id');
			}
		},
		selectedGroup: {
			type: String,
			required: true,
		},
		platformDeleted: Boolean,
		platformUsageData: Object
	},
	data() {
		return {
			// processingSec: 40,
			selectedPrivacyStatus: 'public',
			oauthProcessing: false,
			chosenServer: null,
			stage: 0,
			processing: false,
			error: null,
			serviceLinkError: false,
			serviceLinkConflict: false,
			platformServerInputMode: null,
			configRequired: false,
			linkedServiceCreds: null,
			serviceLinkProcessing: false,
			platform: { enabled: false, configurableMetadata: {} },
			selectedSubChannel: null,
			customPlatform: false,
			internalWorkflow: false,
			// platformTemplates: Platforms,
			platformTemplates: [],
			platformListProcessing: false,
			serviceResponseRecieved: false,
			formErrors: { server: false, streamKey: false, host: false, port: false, streamId: false },
			oauthConnectId: null,
			isAuthRequired: false,
			rtmpAuthUsername: '',
			rtmpAuthPassword: '',
			streamCreateDropdownActive: false,
			maxLengthTitle: 1000,
			maxLengthDescription: 5000,
			showTitleLimitTracking: false,
			isSchedulerInfiniteLoop: false,
			platformUsage: null,
			customMode: 'RTMP',
			customSrtPlatform: {
				server: '',
				host: '',
				port: '',
				streamId: '',
				latency: 120,
				passphrase: ''
			},
			customSrtPlatformErrors: {
				server: '',
				host: '',
				port: '',
				streamId: '',
				streamKey: '',
				latency: '',
				host: '',
				passphrase: ''
			},
			platformDisable: false,
			twitchCategories: [],
			isRtmpPassValid: true,
		};
	},
	computed: {
		user() {
			return this.$store.state.User;
		},
		canSave() {
			const validStage = this.stage > 0;
			return validStage;
		},
		hasPremiumSubscription() {
			const userSubs = this.$store.state.User.subscriptions.map(sub => _.assign({ category: 'restream' }, sub));
			const subscription = userSubs.find(sub => sub.category && sub.category.includes(this.stream.type));
			let isPremiumSubs = false;
			userSubs.forEach((item) => {
				if (item.category.includes(this.stream.type) && item.package && item.package.definition.allowLinkingFbPage !== false) {
					isPremiumSubs = true;
				}
			})
			// And the current sub is not Simulcast yearly & Broadcast trial 7 days (ID 253, 171, 250)
			// ref: https://docs.google.com/spreadsheets/d/1smxssUcDSyK-AM1pzIFHxa5vgXNsnMDAaMbWqrRW6Pc
			return isPremiumSubs && subscription.package._id !== '5fffc31103afd67aa9831cc6' && subscription.package._id !== '5ccc3a3c588ccab4bdd556e7' &&
				subscription.package._id !== '5fffc14a03afd67aa9831cc3' && subscription.package._id !== '5ccc2ee6588ccab4bdd556df';
		},
		subscriptions() {
			return this.$store.state.User.subscriptions.map(sub => _.assign({ category: 'restream' }, sub));
		},
		isBroadcastSubscription() {
			// Check if the user's package is 'Simulcast monthly/yearly'
			const simulcastMonthlyId = '5fffc14a03afd67aa9831cc3'
			const simulcastYearlyId = '5fffc31103afd67aa9831cc6'
			const broadcast7DaysTrial = '5ccc3a3c588ccab4bdd556e7'
			let isBroadcastSubscription = false
			this.$store.state.User.subscriptions.forEach(sub => {
				if (sub.enabled === true && (
					sub.package._id === simulcastMonthlyId
					|| sub.package._id === simulcastYearlyId
					|| sub.package._id === broadcast7DaysTrial
				) && sub.package.category === this.stream.type) {
					isBroadcastSubscription = true
				}
			});
			return isBroadcastSubscription
		}
	},
	watch: {
		isAuthRequired: function (isRequired) {
			if (!isRequired) {
				this.platform.server = this.platform.server.replace(
					/:\/\/.*?:.*?@/,
					'://'
				);
			} else {
				this.rtmpAuthUsername = '';
				this.rtmpAuthPassword = '';
			}
		},
		platformDeleted: function () {
			this.fetchPlatformUsage();
		},
		platformUsageData: function () {
			this.platformUsage = this.platformUsageData;
		},
		rtmpAuthUsername: function (val) {
			if (this.platform.server) {
				this.platform.server = this.platform.server.replace(
					/:\/\/.*?:.*?@/,
					'://'
				);
				if (val && this.rtmpAuthPassword) {
					this.platform.server = this.platform.server.replace(
						'://',
						'://' +
						encodeURIComponent(val) +
						':' +
						encodeURIComponent(this.rtmpAuthPassword) +
						'@'
					);
				}
			}
		},
		rtmpAuthPassword: function (val) {
			if (this.platform.server) {
				this.platform.server = this.platform.server.replace(
					/:\/\/.*?:.*?@/,
					'://'
				);
				if (this.rtmpAuthUsername && val) {
					this.platform.server = this.platform.server.replace(
						'://',
						'://' +
						encodeURIComponent(this.rtmpAuthUsername) +
						':' +
						encodeURIComponent(val) +
						'@'
					);
				}
			}
		}
	},
	async mounted() {

		this.initPlatformTemplates();
	},
	methods: {
		onLegacyModalShow() {
			this.onInit();
		},
		onLegacyModalHide() {
			this.onDismiss();
		},
		onPrivacySettingsChanged(status, platform) {
			this.selectedPrivacyStatus = status;
			platform.configurableMetadata.privacyStatus = status;
			if(_.isArray(this.$refs.youtubePrivacyDropdownInDialog)) {
				this.$refs.youtubePrivacyDropdownInDialog.forEach(x => x.toggleDropdown())
			} else {
				this.$refs.youtubePrivacyDropdownInDialog.toggleDropdown();
			}
		},
		selectInternalWorkflow() {
			this.clearErrors();
			this.stage = 0;
			
			setTimeout(() => {
				this.internalWorkflow = true
				this.stage = 1;
			}, 250);
			
		},
		onChangeGameName: _.debounce(async function (name) {
			if (!this.linkedServiceCreds) return;
			this.twitchCategories = await IntegrationService.getTwitchCategories(this.linkedServiceCreds, name);
			if (this.twitchCategories?.length) this.$refs['twitch-dropdown'].show();
		}, 250),
		onSelectTwitchCategory(category) {
			if (!this.linkedServiceCreds) return;
			this.platform.configurableMetadata.game_id = category.id;
			this.platform.configurableMetadata.game = category.name;
			this.hideLegacyModal();
			this.$forceUpdate();
		},
		onCustomModeChanged(mode) {
			this.customMode = mode
		},
		onInit() { },
		async initPlatformTemplates() {
			this.platformListProcessing = true;
			// Use Vuex store to prevent duplicate platformList.json fetches
			this.platformTemplates = await this.$store.dispatch('Destination/getPlatforms');
			this.platformListProcessing = false;
		},
		getStreamtype() {
			const category = this.stream.type;
			let CategoryName = null;
			if (category == 'live') {
				CategoryName = 'Live Streams'
			} else if (category == 'scheduled') {
				CategoryName = 'Pre-recorded Streams'
			} else if (category == 'restream') {
				CategoryName = 'Multistreams'
			}
			return CategoryName;
		},
		navigatePaymentsPage() {
			const category = this.stream.type;
			window.location.href = `/app/subscribe?category=${category}`;
		},
		async fetchPlatformUsage() {
			// Use Vuex store for platform usage (prevents duplicates)
			const platformUsage = await this.$store.dispatch('PlatformUsage/getPlatformUsage', this.stream.type);
			if (platformUsage) this.platformUsage = platformUsage
		},
		onFacebookPopup(e) {
			e.preventDefault();
			showModal('modal-facebook-integration-prompt'
			);
		},
		stepBack() {
			this.stage--;

			this.clearErrors();
			this.resetPlatform();
		},
		focusServerKeySegment(event) {
			const soruceElement = event.target || event.srcElement;
			if (soruceElement instanceof HTMLInputElement) return;

			this.$refs.segment[0].focus();
		},
		computePlatformServerFromSegments() {
			const { platform } = this;
			// console.log(platform);
			const { serverKeySegments, serverKeySegmentValues } = platform;
			const inputSegments = _.filter(serverKeySegments, { input: true });
			const validSegmentValues = _.compact(serverKeySegmentValues);

			if (_.size(inputSegments) !== _.size(validSegmentValues)) {
				this.platform.server = null;
				return;
			}

			let serverAddr = '';
			_.each(platform.serverKeySegments, (segment, index) => {
				if (segment.exclude) return;

				if (segment.input) {
					serverAddr += serverKeySegmentValues[index];
				} else {
					serverAddr += segment.text || segment;
				}
			});

			this.platform.server = serverAddr;
		},
		async selectPlatform(platform) {
			this.clearErrors();

			if (this.platform.name || this.customPlatform) {
				// Swap content in place; keep the panel open instead of closing and reopening
				this.resetPlatformSelection();
			}
			this.serviceLinkProcessing = false;
			this.selectedSubChannel = null;
			this.serviceResponseRecieved = false;
			this.customPlatform = !platform;
			this.platform = _.assign({}, this.platform, _.cloneDeep(platform));
			this.platformServerInputMode = this.platform.serverKeySegments && Object.keys(this.platform.serverKeySegments).length
				? 'chunks'
				: this.platform.servers
					? 'select'
					: 'input';

			if (this.canConfigureMetadata()) {
				this.platform.configurableMetadata = {
					...this.platform.configurableMetadata,
					title: this.getMetadataPropValue('title'),
					description: this.getMetadataPropValue('description'),
					persistent: false
				};
			}

			let preselectedServer = this.platform.servers && this.platform.servers[0];
			if (preselectedServer) {
				preselectedServer = preselectedServer.value || preselectedServer;
				this.platform.server = preselectedServer;
			}

			let canConfiguredOAuth = this.platform.canLinkService;
			
			// Hardcode LinkedIn to always use Connect to... method
			if (this.platform.name === 'LinkedIn' && this.user && this.user._id === '6523a212c7eacf62b13abfc3') {
				canConfiguredOAuth = true;
				this.configRequired = false;
				this.platform.customServer = false;
				this.platform.serviceAuthorization = {
					enabled: true,
					metadata: {
						fields: [
							// {
							// 	key: "title",
							// 	required: true
							// },
							{
								key: "description",
								value: "Multistreaming with Castr"
							}
						]
					},
					// subChannelRequired: true,
					// subChannelBasedMetadata: true,
					// subChannelFieldLabel: "Select Event"
				};
			} else if (canConfiguredOAuth && this.platform.oauthCheckRequired) {
				canConfiguredOAuth = false;
				const usersubs = this.subscriptions;
				const basesub = _.find(usersubs, { category: this.stream.type });
				if (basesub) {
					let oauthIntegrationsRules = basesub.oauthIntegrations;
					// if (!oauthIntegrationsRules && basesub.definitionOverride) {
					//   oauthIntegrationsRules = basesub.definitionOverride.oauthIntegrations
					// }

					if (!oauthIntegrationsRules) {
						// extract from sub def overrides
						if (basesub.definitionOverride) {
							oauthIntegrationsRules = basesub.definitionOverride.oauthIntegrations;
						}

						// extract from sub pack def
						if (!oauthIntegrationsRules) {
							oauthIntegrationsRules = basesub.package.definition.oauthIntegrations;
						}
					}

					const canlinkService = _.find(oauthIntegrationsRules, { template: this.platform.slug || this.platform.name, enabled: true });
					canConfiguredOAuth = !!canlinkService;
				}

				// We allow scheduled stream with datetime mode connect to Facebook via API
				if (this.stream.type === 'scheduled') {
					canConfiguredOAuth = true;
					const schedulerConfig = await StreamService.getStreamScheduleSettings(this.stream._id) || {};
					if (schedulerConfig.mode === 'loop') {
						this.isSchedulerInfiniteLoop = true;
					} else this.isSchedulerInfiniteLoop = false;
				}
			}

			// this.configRequired = !this.platform.canLinkService
			this.configRequired = !canConfiguredOAuth;

            this.shouldConfigureServer();
            if (this.platform.name && this.platform.server) {
                console.log('Platform has both name and server');
                } else {
                console.warn('Missing name or server in platform:', this.platform);
                }
            this.$emit('platform-selected', this.platform);
            
			// move to next step
			this.stage = 1;
		},
		resetPlatformSelection() {
			this.platform = {
				enabled: false,
				configurableMetadata: {}
			};

			this.rtmpAuthUsername = '';
			this.rtmpAuthPassword = '';
			this.customPlatform = false;
			this.configRequired = false;
			this.linkedServiceCreds = null;
			this.selectedSubChannel = null;
			this.internalWorkflow = false;
		},
		unselectPlatform() {
			this.resetPlatformSelection();
			this.stage = 0;
		},
		onInputChange(prop) {
			this.formErrors[prop] = false;


			if (prop === 'port' && this.customSrtPlatform.port) {
				const portNum = parseInt(this.customSrtPlatform.port)
				if (!portNum || /\D/.test(this.customSrtPlatform.port)) {
					this.customSrtPlatformErrors.port = 'Port must be a number'
					// replace value
					this.customSrtPlatform.port = ''
				}
				else if (portNum > 65535) {
					this.customSrtPlatformErrors.port = 'Port must be equal to or below 65535'
				} else {
					this.customSrtPlatformErrors.port = ''
				}
			} else {
				this.customSrtPlatformErrors.port = ''
			}

			if (prop === 'latency' && this.customSrtPlatform.latency) {
				const portNum = parseInt(this.customSrtPlatform.latency)
				if (!portNum || /\D/.test(this.customSrtPlatform.latency)) {
					this.customSrtPlatformErrors.latency = 'Latency must be a number'
					// replace value
					this.customSrtPlatform.latency = ''
				} else {
					this.customSrtPlatformErrors.latency = ''
				}
			} else {
				this.customSrtPlatformErrors.latency = ''
			}

			// remove unnecessary key chars
			if (prop === 'streamKey') {
				const regexp = new RegExp('^(?!.*@.*@)(?:[A-Za-z0-9\\-._~!$&\'()*+,;=:@%?#/]|%[0-9A-Fa-f]{2})+$', 'i');
				if (/\^/.test(this.platform.streamKey) || !regexp.test(this.platform.streamKey)) {
					this.customSrtPlatformErrors.streamKey = 'invalid streaming key'
					this.error = { message: 'Streaming key is invalid' }
					
					// replace value
					// this.customSrtPlatform.host = ''
				} else {
					this.customSrtPlatformErrors.streamKey = ''
				}
			}
			if (prop === 'streamKey') {
				setTimeout(() => {
					this.platform[prop] = utils.resolveStreamKey(
						this.platform[prop]
					);
				});
			}
			if (prop === 'host') {
				this.customSrtPlatform.host = this.customSrtPlatform.host.replace(/\s/g, '');
				if (/\^/.test(this.customSrtPlatform.host)) {
					this.customSrtPlatformErrors.host = 'invalid host format'
					// replace value
					// this.customSrtPlatform.host = ''
				} else {
					this.customSrtPlatformErrors.host = ''
				}
			}
			if (prop === 'streamId') {
				this.customSrtPlatform.streamId = this.customSrtPlatform.streamId.replace(/\s/g, '');
				if (/\^/.test(this.customSrtPlatform.streamId)) {
					this.customSrtPlatformErrors.streamId = 'invalid streamId format'
					// replace value
					// this.customSrtPlatform.host = ''
				} else {
					this.customSrtPlatformErrors.streamId = ''
				}
			}
			// setTimeout(() => {
			// 	if (
			// 		this.platform.server &&
			//    !this.platform.server.match(/^[a-z]+:\/\//i)
			// 	) {
			// 		this.platform.server = 'rtmp://' + this.platform.server;
			// 	}
			// });
			if (prop === 'server') {
				this.platform.server = this.platform?.server?.replace(/\s/g, '');
				if (/\^/.test(this.platform.server)) {
					this.customSrtPlatformErrors.server = 'invalid destination ingest address'
					// replace value
					// this.customSrtPlatform.host = ''
				} else {
					this.customSrtPlatformErrors.server = ''
				}
			}
			setTimeout(() => {
				if (prop === 'server' && this.platform.server) {
					let userAuthMatch;

					if (
						(userAuthMatch = this.platform.server.match(
							/:\/\/(.*?):(.*?)@/
						))
					) {
						this.isAuthRequired = true;

						setTimeout(() => {
							this.rtmpAuthUsername = decodeURIComponent(
								userAuthMatch[1]
							);
							this.rtmpAuthPassword = decodeURIComponent(
								userAuthMatch[2]
							);
						}, 100);
					}
				}
			}, 100);
		},
		selectServer(server) {
			this.chosenServer = server.text
			this.platform.server = server.value;

		},
		shouldConfigureServer() {
			const haveConfigured =
				this.platform.server && this.platformServerInputMode === 'auto';


			const result = !haveConfigured &&
				(this.customPlatform || this.platform.customServer || this.hasMultiplePlatformServers(this.platform));
			if (result) {
				if (this.platform.name === 'facebook live' && !this.platform.server) {
					this.platform.server = 'rtmps://live-api-s.facebook.com:443/rtmp'
				}
				if (this.platform.name === 'youtube events' && !this.platform.server) {
					this.platform.server = 'rtmp://a.rtmp.youtube.com/live2'
				}
				if ((this.platform.name || '').toLowerCase() === 'vimm.tv' && !this.platform.server) {
					this.platform.server = 'rtmp://rtmp.livepeer.com/live'
				}
			}
			return result;
		},
		checkServerInputMode(matchInputMode) {
			return (
				this.platformServerInputMode &&
				this.platformServerInputMode === matchInputMode
			);
		},
		shouldShowServiceLinkingPrompt() {
			return !this.configRequired;
			// return this.platform.canLinkService && !this.configRequired
			// return this.platform.canLinkService;
			// const bool = this.platform.canLinkService && !this.platform.ignoreServiceLinking
			// console.log('shouldShowServiceLinkingPrompt', bool)
			// return bool
		},
		ignoreServiceLinking() {
			if (this.platform.customServerPremiumFeat) {
				const baseSub = this.subscriptions.find(sub => sub.category && sub.category.includes(this.stream.type));
				const isTrialSub = /trial/gi.test(baseSub.package.name || '');
				if (isTrialSub) {
					showModal('modal-custom-server-premium-feat'
					);
					return;
				}
			}

			this.configRequired = true;
			this.platform.customServer = true;
			// this.platform.canLinkService = false;
			// this.platform.ignoreServiceLinking=true
			// console.log(this.platform);
		},
		hasMultiplePlatformServers(platform) {
			return (
				_.size(platform.servers) > 1 || _.size(platform.serverKeySegments)
			);
		},
		getServiceOAuthUrl() {
			if (this.isSchedulerInfiniteLoop) return;
			const oauthFactoryName =
				this.platform.oauthSlug || this.platform.slug || this.platform.name;
			const pathname = `integrations/${oauthFactoryName}/oauth`;
			const connectId = v4()
			if (!this.oauthConnectId) this.oauthConnectId = connectId;

			const searchParams = `redirect=1&user=${this.user._id || this.user.id}&stream=${this.stream._id
				}&connectId=${this.oauthConnectId}`;
			let routeUrl = `${process.env.VUE_APP_APP_API_BASE}/${pathname}?${searchParams}`;
			console.log(routeUrl);
			if (window.todesktop && (oauthFactoryName == 'facebook')) {
				window.todesktop.contents.openUrlInBrowser(routeUrl);
			} else {
				window.open(routeUrl, '_blank');
			}

		},
		cancelServiceLinking() {
			this.serviceLinkError = false;
			this.serviceLinkConflict = false;
			this.serviceLinkProcessing = false;
		},
		async onServiceAuthURLTap() {
			// Check if there is any available platform to add
			try {
				const isAvailableSlot = await StreamService.addStreamPlatform(this.stream._id, {
					template: this.customPlatform ? 'custom' : this.platform.name,
					server: 'test',
					key: 'test',
					enabled: false,
					preChecking: true
				})
			} catch (error) {
				console.error(error.stack);
				if (error.message === 'Please upgrade your subscription to add more streams and platforms.') {
					return this.error = error;
				}
			}

			this.serviceLinkConflict = false;
			this.serviceLinkProcessing = true;

			// const serviceName = this.platform.name;
			const connectId = this.oauthConnectId;
			// const connectId = '17379bd5-6cbc-4f3e-946c-936fa9aa85fc';
			this.oauthConnectId = null;

			// const ackTag = 'oauth-link'
			// Vue.appEvents.emit('ack.listen', ackTag, connectId)
			// const subkey = [ackTag, connectId].join('.')

			// #DISABLED FOR DEBUG
			// Vue.appEvents.on(subkey, this.onServiceAuthResponse)
			this.oauthProcessing = true;
			this.listenAckEventResponse(connectId, this.onServiceAuthResponse);
			// #ENABLED FOR DEBUG
			// this.onServiceAuthResponse({linkedMeta: "5dc40186ed240b447c1d911b"})
		},
		async listenAckEventResponse(key, callback) {
			if (this.oauthProcessing && !this.serviceLinkProcessing) return;
			const ackRes = await IntegrationService.getAckByKey(key);
			// console.log('ackRes', ackRes)
			if (ackRes && ackRes.success) {
				callback(ackRes.data);
				this.oauthProcessing = false;
			} else {
				setTimeout(() => {
					this.listenAckEventResponse(key, callback);
				}, 4000);
			}
		},
		hasMetaProp(propname) {
			if (
				!this.linkedServiceCreds ||
				!this.platform.serviceAuthorization ||
				!propname
			)
				return;

			const { metadata } = this.platform.serviceAuthorization;

			// let canConfigure = false
			const { fields } = metadata;

			// perform multi key matching `OR`
			if (!_.isArray(propname)) {
				propname = [propname];
			}

			let keyFound = false;
			_.each(propname, key => {
				// check for property existences
				if (keyFound) return;
				const field = _.find(fields, { key });
				keyFound = !!field;
			});

			return keyFound;
		},
		canConfigureMetadata(propname) {
			if (
				!this.linkedServiceCreds ||
				!this.platform.serviceAuthorization ||
				(this.platform.serviceAuthorization &&
					this.platform.serviceAuthorization.subChannelBasedMetadata &&
					!this.platform.subChannel &&
					propname)
			)
				return;

			const { metadata } = this.platform.serviceAuthorization;
			if (propname === undefined) {
				return !!metadata;
			}

			let canConfigure = false;
			const { fields } = metadata;

			// check for property being disabled
			const field = _.find(fields, { key: propname });
			canConfigure = field && !field.disabled;
			return canConfigure;
		},
		getMetadataPropValue(propname, getDefinition) {
			const { fields } = this.platform.serviceAuthorization.metadata;
			const field = _.find(fields, { key: propname });
			return getDefinition ? field : field && field.value;
		},
		setMetadataPropValue(propname, value) {
			this.platform.configurableMetadata[propname] = value;
		},
		showFacebookGroupsGuide() {
			showModal('modal-facebook-groups-guide');
		},
		async setSubChannels(oauthMetaId) {
			this.platform.subChannelList = await IntegrationService.getServiceSubChannels(oauthMetaId);
			if (this.platform.subChannelList.length) {
				if (this.platform.serviceAuthorization && this.platform.serviceAuthorization.autoSelectDefaultSubChannel) {
					this.changeSubChannelSelection(this.platform.subChannelList[0]);
				}
			}
		},
		onSubchannelListToggle(state) {
			this.streamCreateDropdownActive = state;
		},
		isSubChannelDisabled(subChannelItem) {
			let isDisabled = false;
			if (!this.hasPremiumSubscription && /facebook/g.test(this.platform.name)) {
				isDisabled = subChannelItem.id !== 0;
			}
			return isDisabled;
		},
		changeSubChannelSelection(subChannelItem) {
			if (this.isSubChannelDisabled(subChannelItem)) return;

			this.selectedSubChannel = subChannelItem;
			const subchannelSlug = (subChannelItem.type || '-') + '@' + subChannelItem.id;
			this.platform.subChannel = subchannelSlug;
			this.onSubChannelChange();
		},
		async onSubChannelChange() {
			let selectedSubChannel = this.platform.subChannel;
			if (selectedSubChannel === 'new') return;
			const subChannelId = selectedSubChannel.split('@')[1];
			selectedSubChannel = this.platform.subChannelList.find(({ id }) => id === subChannelId);

			if (this.platform.serviceAuthorization && this.platform.serviceAuthorization.subChannelBasedMetadata) {
				if (selectedSubChannel) {
					if (selectedSubChannel.metadata) {
						const chMeta = selectedSubChannel.metadata;
						this.platform.configurableMetadata = {
							...this.platform.configurableMetadata,
							title: chMeta.title,
							description: chMeta.description
						};
					}
				}
			}
		},
		async onServiceAuthResponse(response) {
			if (this.serviceResponseRecieved) return;
			this.serviceResponseRecieved = true;
			if (!response || response.error) {
				this.serviceLinkError = true;
				return;
			}
			const oauthMetaId = response.linkedMeta;
			// acknowledge UI, authorization was successful
			this.linkedServiceCreds = oauthMetaId;

			// check for linking conflicts
			let linkResult;
			try {
				linkResult = await IntegrationService.checkIntegrationConflict(this.stream._id, oauthMetaId);
			} catch (err) {
				// console.log('integration-conflict-check-error', err);
				window.alert('Unable to verify this connection. Please try again.');
			}

			if (!linkResult || linkResult.linked) {
				// conflicts are there
				this.serviceLinkError = true;
				this.serviceLinkConflict = true;
				this.linkedServiceCreds = null;
				return;
			}

			// check if serice supports metadata integration
			const { serviceAuthorization } = this.platform;
			// const { serviceAuthorization = true } = this.platform;
			if (serviceAuthorization && serviceAuthorization.subChannelRequired) {
				await this.setSubChannels(oauthMetaId);
			}

			let metaOverrides = {};
			const ingestConfParams = {};

			if (serviceAuthorization && serviceAuthorization.subChannelBasedMetadata) {
				// this.configRequired = true
				// this.platformServerInputMode = 'auto'
				metaOverrides = {
					title: '',
					description: '',
					game: ''
				};
				ingestConfParams.subChannelBasedMetadata = true;
			}
			// console.log('serviceAuthorization', serviceAuthorization);
			

			const ingest = await this.setServiceIngest(oauthMetaId, ingestConfParams);
			if (!ingest) return;
			let configRequired = false;
			if (ingest.server) {
				this.platformServerInputMode = 'auto';
			} else {
				configRequired = true;
			}

			if (serviceAuthorization && serviceAuthorization.metadata) {
				configRequired = true;
				await this.setupServiceMetadata(oauthMetaId, metaOverrides);
			}

			this.configRequired = configRequired;
			if (configRequired) return;

			this.onSavePlatform();
		},
		async setServiceIngest(oauthMetaId, params) {
			let ingest;
			try {
				ingest = await IntegrationService.getServiceIngest(
					oauthMetaId,
					params
				);
			} catch (e) {
				this.serviceLinkError = true;
				return;
			}

			if (!ingest) {
				this.serviceLinkError = true;
				return;
			}

			if (ingest.streamCreationRequired) {
				this.platform.streamCreationRequired = true;
				ingest._id = oauthMetaId;
				ingest.key = '#streamkey';
				ingest.server = '#serveraddr';
			}

			this.platform.enabled = true;
			this.platform.streamKey = ingest.key;
			this.platform.server = ingest.server;
			this.linkedServiceCreds = ingest._id;

			return ingest;
		},
		async setupServiceMetadata(oauthMetaId, metaOverrides = {}) {
			// get existing metadata details
			try {
				const metaprops = {
					title: this.getMetadataPropValue('title'),
					description: this.getMetadataPropValue('description'),
					game: this.getMetadataPropValue('game')
				};

				for (const prop in metaOverrides) {
					if (Object.prototype.hasOwnProperty.call(metaOverrides, prop)) {
						metaprops[prop] = metaOverrides[prop];
					}
				}

				if (this.platform.streamCreationRequired) {
					this.platform.configurableMetadata = _.assign(
						{},
						this.platform.configurableMetadata,
						{
							title: metaprops.title,
							description: metaprops.description,
							game: metaprops.game,
							persistent: false
						}
					);
				} else {
					let streamMeta = await IntegrationService.getIntegrationMetadata(oauthMetaId);
					streamMeta.persistent = false;

					streamMeta = Object.assign({}, streamMeta, metaOverrides);
					this.platform.configurableMetadata = streamMeta;
				}

				// check for fixed/disabled fields
				['title', 'description', 'game'].forEach(prop => {
					const metaField = this.getMetadataPropValue(prop, true);
					const { disabled } = metaField || {};
					let { value: metavalue } = metaField || {};
					metavalue = prop in metaprops ? metaprops[prop] : metavalue;
					if (disabled) this.platform.configurableMetadata[prop] = metavalue;
				});
			} catch (e) {
				console.log(e);
			}

			// Set up platform title limit for Youtube event
			if (this.platform.name === 'youtube events') {
				if (this.platform.configurableMetadata && _.isString(this.platform.configurableMetadata.title)) {
					this.showTitleLimitTracking = true
				}
				this.maxLengthTitle = 100
			} else {
				this.showTitleLimitTracking = false
				this.maxLengthTitle = 1000
			}
		},
		isServiceAlreadyLinked() {
			// const currentTemplate = this.platform.name
			// const linked = _.find(
			//   this.stream.platforms,
			//   platform =>
			//     platform.template === currentTemplate && platform.linkedServiceCreds
			// )
			// return !!linked;
			return false;
		},
		async onSavePlatform() {
			// this.processingSec = 40
			// let intervalctrl = setInterval(() => {
			//   if (!this.processingSec) {
			//     clearInterval(intervalctrl)
			//     return
			//   }

			//   this.processingSec -= 1
			// }, 1000)
			this.checkPassword()
			this.error = null;
			if (!this.validateForm() && !this.platform.streamCreationRequired || !this.isRtmpPassValid) {
				// window.alert('warning: form not completely filled')
				return;
			}

			if (
				this.linkedServiceCreds &&
				this.platform.serviceAuthorization &&
				this.platform.serviceAuthorization.subChannelRequired &&
				!this.platform.subChannel
			) {
				let channelType = 'sub channel';
				if (this.platform.template === 'youtube') {
					channelType = 'event';
				}

				window.alert(`Please select a ${channelType}.`);
				return;
			}

			this.processing = true;
			let payload;
// console.log('addre', this.platform)
			if (this.customMode === 'SRT' && this.customPlatform) {
				if (this.customSrtPlatform.host.endsWith('/')) {
					this.customSrtPlatform.host = this.customSrtPlatform.host.replace(/\/$/, '');
				}
				payload = {
					enabled: this.platform.enabled,
					server: this.modifySrtUrl(this.customSrtPlatform.host),
					key: this.customSrtPlatform.streamId,
					template: 'custom',
					mode: 'srt',
					port: this.customSrtPlatform.port,
					latency: this.customSrtPlatform.latency,
					passphrase: this.customSrtPlatform.passphrase
				};
			} else {
				// let serverAddr = this.platform.server
				// serverAddr = _.replace(serverAddr, /^rtmps/gi, 'rtmp')
				// serverAddr = _.replace(serverAddr, /\:443/gi, ':80')
				let serverAddr = this.platform.server;
				serverAddr = utils.resolveURL(serverAddr, true);

				let streamKey = this.platform.streamKey;
				streamKey = utils.resolveStreamKey(streamKey);

				payload = {
					enabled: this.platform.enabled,
					server: serverAddr,
					key: streamKey,
					template: this.customPlatform ? 'custom' : this.platform.name
				};
			}

			// payload.serviceMeta = {}
			if (this.canConfigureMetadata()) {
				const {
					title,
					description,
					privacyStatus,
					game,
					game_id,
					persistent
				} = this.platform.configurableMetadata;
				const metaUpdates = {};
				if (title) {
					metaUpdates.title = title;
				}
				if (description) {
					metaUpdates.description = description;
				}
				if (game) {
					metaUpdates.game = game;
				}
				if (game_id) {
					metaUpdates.game_id = game_id;
				}
				if (persistent) {
					metaUpdates.persistent = persistent;
				}
				if(privacyStatus) {
					metaUpdates.privacyStatus = privacyStatus;
				}
				payload.serviceMeta = metaUpdates;
			}

			if (this.platform.streamCreationRequired) {
				let ingest;
				try {
					const metaprops = payload.serviceMeta;
					const params = {
						forceCreate: 1,
						streamTitle: metaprops.title,
						streamDescription: metaprops.description || metaprops.game,
						persistent: metaprops.persistent,
						title: metaprops.title,
						description: metaprops.description || metaprops.game,
						privacyStatus: metaprops.privacyStatus,
					};

					const subChannelId = this.platform.subChannel;
					if (subChannelId) {
						params.subChannel = subChannelId;
						payload.serviceMeta.subChannel = subChannelId;

						// let subChannelOriginalId = _.split(subChannelId, '@').pop()
						const [subChannelType, subChannelOriginalId] = _.split(subChannelId, '@');
						const subChannelObject = this.platform.subChannelList.find((c) => {
							const chId = String(c.id);
							return chId !== '0' && chId === subChannelOriginalId;
						});

						if (subChannelObject) {
							payload.serviceMeta.subChannelName = subChannelObject.name;

							// Add scheduleTime to prevent the BE override the current schedule time
							params.scheduleTime = subChannelObject.scheduleTime;
						}

						if (subChannelType === '-' && metaprops.title) {
							payload.serviceMeta.subChannelName = metaprops.title;
						}
					}

					// We use POST request here to avoid the case of the querystring too large, will be get the 414 error code from the back-end side
					ingest = await IntegrationService.getServiceIngest(
						this.linkedServiceCreds,
						params,
						'post'
					);
				} catch (e) {
					console.log(e);
					this.processing = false;

					const wasFacebookGroup =
						/facebook/g.test(this.platform.name || '') &&
						this.selectedSubChannel.type === 'group';
					if (wasFacebookGroup) {
						this.showFacebookGroupsGuide();
					} else {
						window.alert(
							'Unable to retrieve the ingest configuration. Please try again.' +
							(_.get(e, 'message') || e)
						);
					}
				}

				if (!ingest) {
					this.serviceLinkError = true;
					return;
				}

				this.linkedServiceCreds = ingest._id;
				payload.key = utils.resolveStreamKey(ingest.key, true);
				payload.server = utils.resolveURL(ingest.server, true);
				payload.ignoreServiceMetaUpdates = true;

				if (ingest.subChannelId) {
					payload.serviceMeta.subChannel = ingest.subChannelId;
				}
			}

			if (this.linkedServiceCreds) {
				payload.enabled = false;
				payload.linkedServiceCreds = this.linkedServiceCreds;
			}

			try {
				// const platform = await StreamService.addStreamPlatform(
				// 	this.stream._id,
				// 	payload
				// );
				payload.icon = this.platform.icon;
				this.$emit('platform-saved', payload, this.selectedGroup);
				// console.log('platform saved', payload)
				// this.fetchPlatformUsage();
				setTimeout(() => this.dismiss(), 600);
			} catch (err) {
				this.error = err;
				this.processing = false;
				// check if subscripiton error
				if (err && _.indexOf(err.message, 'subscription') > -1) {
					this.error.subscription = true;
				}
			}
		},
		dismiss() {
			this.hideLegacyModal();
			this.onDismiss();
		},
		modifySrtUrl(url) {
			if (url?.startsWith('srt://')) return url
			return 'srt://' + url
		},
		validateForm() {
			let props = ['server', 'streamKey'];
			let fields = this.platform

			if (this.customMode === 'SRT' && this.customPlatform) {
				props = ['host', 'port']
				fields = this.customSrtPlatform
			}

			let valids = 0;
			_.each(props, prop => {
				let val = fields[prop];
				if (prop === 'server') {
					let { valid } = utils.validateURL(val, { validatePathname: false });
					if(valid) {
						const platformName = this.platform?.name?.toLowerCase() || '';
						if(platformName.includes('tiktok')) {
							valid = val.includes('tiktokcdn');
						} else if(platformName.includes('instagram')) {
							valid = val.includes('fbcdn.net') || val.includes('instagram.com');
						} else if (platformName.includes('kick')) {
							valid = val.includes('global-contribute');
						}
					}
					if (!valid) val = null;
				}

				if (val) valids++;
				// else this.formErrors[prop] = true;

				this.formErrors[prop] = !val;
			});

			let srtValidation = true
			if (this.customMode === 'SRT') {
				if (this.customSrtPlatform.host.includes(`:${this.customSrtPlatform.port}`)) {
					this.customSrtPlatform.host = this.customSrtPlatform.host.replace(`:${this.customSrtPlatform.port}`, '')
				}

				srtValidation = srtValidation && !this.customSrtPlatformErrors.port
				srtValidation = srtValidation && !this.customSrtPlatformErrors.latency
			}

			return valids === props.length && srtValidation;
		},
		onDismiss() {
			// clear up cache
			this.resetPlatform();
			this.clearErrors();

			// lazy clear
			setTimeout(() => {
				this.stage = 0;
				this.processing = false;
			}, 1000);
		},
		clearErrors() {
			this.error = null;
			this.formErrors.server = false;
			this.formErrors.streamKey = false;
			this.formErrors.host = false;
			this.formErrors.port = false;
			this.formErrors.streamId = false;

			this.customSrtPlatformErrors = {
				host: '',
				latency: '',
				port: '',
				server: '',
				streamId: '',
				streamKey: '',
				passphrase: ''
			}
		},
		resetPlatform() {
			this.platform = { enabled: false };
			this.serviceLinkError = false;
			this.linkedServiceCreds = null;
			this.serviceLinkProcessing = false;
			this.rtmpAuthUsername = '';
			this.rtmpAuthPassword = '';
			this.internalWorkflow = false;

			this.customMode = 'RTMP'
			this.customSrtPlatform = {
				host: '',
				port: '',
				streamId: '',
				latency: 120,
				passphrase: ''
			}
		},
		checkPassword() {
			if (this.rtmpAuthPassword.includes('@')) {
				this.isRtmpPassValid = false
			} else this.isRtmpPassValid = true
		},
		isError(field) {
			return this.formErrors[field] || this.customSrtPlatformErrors.host > 0 ? true : false
		},
		errorText(field) {
			if (this.formErrors[field]) return 'Required field'
			if (this.customSrtPlatformErrors[field].length > 0) return this.customSrtPlatformErrors[field]
		},
		onCastrStreamPlatformSaved(platform) {
			this.$emit('platform-saved', platform);
			// this.fetchPlatformUsage();
			setTimeout(() => this.dismiss(), 600);
		}
	},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.custom-platform-type ul {
	background: var(--c-dark-3);
	border-radius: 6px;
	padding: 3px;
}

.custom-platform-type li {
	border-radius: 4px;
	display: inline-block;
	width: 100%;
	padding: 4px 5px;
	cursor: pointer;
}

.custom-platform-type li.active {
	background: var(--c-dark-5);
}

.facebooklive-disable-plat,
.youtubeevents-disable-plat {
	pointer-events: none;
	opacity: .4;
}

.error {
	color: #fff;
}

.modal-container {
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.platform-list {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 0 12px 16px;
	position: relative;
}

.platform-list>li:empty {
	display: none;
}

.platform-item {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border-radius: 6px;
	cursor: pointer;
}

.platform-item.active {
	background-color: var(--c-main-1);
}

.internal-workflow.active {
	background-color: var(--c-main-1);
}

.platform-icon img {
	max-height: 40px;
	object-fit: contain;
	margin-bottom: .5rem;
	width: 100%;
}

.platform-icon_secondary {
	max-height: 40px;
	object-fit: contain;
}

.second-modal-content {
	height: 100%;
	overflow-x: hidden;
	overflow-y: auto;
	padding-bottom: 20px;
}

.second-modal {
	position: fixed;
	top: 0;
	left: 510px;
	background-color: var(--c-dark-2);
	width: 410px;
	height: 100%;
	z-index: 51;
	opacity: 0;
	visibility: hidden;
	transform: translateX(-24px);
	pointer-events: none;
	/* delay visibility so the fade-out plays before the panel is hidden */
	transition: transform 0.25s ease-out, opacity 0.25s ease-out, visibility 0s linear 0.25s;
	border-left: 1px solid var(--c-dark-3);
	border-right: 1px solid var(--c-dark-3);
}

.second-modal.showform {
	opacity: 1;
	visibility: visible;
	transform: translateX(0);
	pointer-events: auto;
	transition: transform 0.25s ease-out, opacity 0.25s ease-out;
}

/* Crossfade when switching between platforms while the panel stays open */
.second-modal-swap-enter-active,
.second-modal-swap-leave-active {
	transition: opacity 0.15s ease;
}

.second-modal-swap-enter-from,
.second-modal-swap-leave-to {
	opacity: 0;
}

.expand.second-modal.showform {
	width: 510px;
}

#service-subchannels-dropdown .hint-upgrade {
	display: none;
}

#service-subchannels-dropdown .disabled .hint-upgrade {
	display: block;
}

.lined {
	position: relative;
	display: flex;
	align-content: center;
	justify-content: center;
	white-space: nowrap;
}

.lined:before {
	content: '';
	position: relative;
	border-top: 1px solid var(--c-dark-3);
	width: 100%;
	top: 12px;
	margin-right: 10px;
}

.lined:after {
	content: '';
	position: relative;
	border-top: 1px solid var(--c-dark-3);
	width: 100%;
	top: 12px;
	margin-left: 10px;
}

:deep(* .dropdown-menu_md),
.tests {
	max-height: 300px;
	overflow-y: auto;
	max-width: 100%;
}

:deep(.page-item.dropdown-item) {
	white-space: normal;
}

.platform-label {
	text-transform: capitalize;
	text-align: center;
}

.add-platform-title {
	font-size: 20px;
}

.platform-item:hover {
	background-color: var(--c-dark-3);
}

.doc img {
	max-width: 16px;
	width: 100%;
	transform: translateY(-1px);
}

@media (max-width: 767px) {
	.showform.second-modal {
		top: 70px;
		left: 0;
		z-index: 1030;
		max-width: 100%;
	}
}
</style>
